import { store } from '../lib/store';

//Code that runs in app.js
export const init = () => {

	window.addEventListener('scroll', () => {

		if (window.pageYOffset > 0) {
			if(!store.getState().customState.scrolled) {
				store.dispatch({
					type: 'SCROLLED',
					scrolled: true
				})
			}
		} else {
			if (store.getState().customState.scrolled) {
				store.dispatch({
					type: 'SCROLLED',
					scrolled: false
				})
			}
		}
	});

	document.addEventListener('focusin', (event) => {
		const focusedElement = event.target;
		const isInFooter = focusedElement.closest('.site-footer');

		try {
			if (isInFooter && focusedElement.matches(':focus-visible')) {

				window.scrollTo({
					top: document.documentElement.scrollHeight,
					behavior: 'smooth' // Gör rullningen mjuk istället för ett hårt hopp
				});

			}
		} catch (e) {
			if (isInFooter) {
				window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
			}
		}
	});

};

export const formatDate = (dateString) => {
	if (!dateString) return '';
	const date = new Date(dateString);
	if (isNaN(date.getTime())) return dateString; // Returnera originalet om det inte är ett giltigt datum
	return new Intl.DateTimeFormat('sv-SE', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	}).format(date);
}